export default "__VITE_PUBLIC_ASSET__8a14dfe6__"